import { Card, CardContent } from '@/components/ui/Card.tsx';
import { Skeleton } from '@/components/ui/Skeleton.tsx';

const BillRow = () => (
  <div className="flex flex-row items-center justify-between">
    <Skeleton className="h-4 w-40" />
    <Skeleton className="h-4 w-20" />
  </div>
);

/**
 * Szkielet potwierdzenia rezerwacji — dla wejścia z linku, gdzie loader trasy
 * musi najpierw pobrać podsumowanie po tokenie.
 */
const BookingPublicSummarySkeleton = () => (
  <div className="min-h-screen py-8">
    <div className="mx-auto flex max-w-2xl flex-col gap-2 px-4">
      <Card>
        <CardContent className="flex flex-col gap-4">
          <Skeleton className="h-8 w-28 self-start" />
          <Skeleton className="mx-auto size-12 rounded-md" />
          <Skeleton className="mx-auto h-6 w-52" />

          <div className="space-y-2">
            <Skeleton className="h-8 w-64" />
            <Skeleton className="h-5 w-40" />
          </div>

          <div className="space-y-1">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-5 w-32" />
          </div>

          <div className="flex flex-wrap gap-6">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-5 w-28" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="space-y-3">
          <Skeleton className="h-5 w-44" />
          <BillRow />
          <BillRow />
        </CardContent>
      </Card>

      <Card>
        <CardContent className="space-y-3">
          <Skeleton className="h-5 w-52" />
          <BillRow />
          <BillRow />
          <BillRow />
        </CardContent>
      </Card>

      <Card>
        <CardContent className="flex items-center justify-between py-4">
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-5 w-24" />
        </CardContent>
      </Card>

      <Card>
        <CardContent className="space-y-3">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
        </CardContent>
      </Card>
    </div>
  </div>
);

export default BookingPublicSummarySkeleton;
